/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Product_Classification_Delete_ErrorInputs */

const vi_toast_product_classification_delete_error = /** @type {(inputs: Toast_Product_Classification_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa phân loại thất bại`)
};

/**

* @param {Toast_Product_Classification_Delete_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_product_classification_delete_error = /** @type {((inputs?: Toast_Product_Classification_Delete_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Product_Classification_Delete_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_product_classification_delete_error(inputs)
});